import * as React from 'react';
import Typography from "@mui/material/Typography";

interface DetailsInfoRowProps {
    title: string
    value: string
    isBold?: boolean
    isLink?: boolean
    link?: string
}

export default function DetailsInfoRow({title, value, isBold = true, isLink = false, link = ""}: DetailsInfoRowProps) {
    return (
        <Typography variant="body1">
            {title}<br/>
            {isLink && <a href={link} target="_blank" rel="noopener noreferrer">{value}</a>}
            {isBold && <b>{value}</b>}
            {!isLink && !isBold && value}
        </Typography>
    );
}